var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60893 1.74561H2.93661C2.53098 1.74561 2.20215 2.07444 2.20215 2.48007V7.62131C2.20215 8.02694 2.53098 8.35577 2.93661 8.35577H6.60893C7.01456 8.35577 7.34339 8.02694 7.34339 7.62131V2.48007C7.34339 2.07444 7.01456 1.74561 6.60893 1.74561Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.689 1.74561H11.0167C10.6111 1.74561 10.2822 2.07444 10.2822 2.48007V4.68346C10.2822 5.08909 10.6111 5.41792 11.0167 5.41792H14.689C15.0946 5.41792 15.4235 5.08909 15.4235 4.68346V2.48007C15.4235 2.07444 15.0946 1.74561 14.689 1.74561Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.689 8.35596H11.0167C10.6111 8.35596 10.2822 8.68479 10.2822 9.09042V14.2317C10.2822 14.6373 10.6111 14.9661 11.0167 14.9661H14.689C15.0946 14.9661 15.4235 14.6373 15.4235 14.2317V9.09042C15.4235 8.68479 15.0946 8.35596 14.689 8.35596Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60893 11.2939H2.93661C2.53098 11.2939 2.20215 11.6228 2.20215 12.0284V14.2318C2.20215 14.6374 2.53098 14.9663 2.93661 14.9663H6.60893C7.01456 14.9663 7.34339 14.6374 7.34339 14.2318V12.0284C7.34339 11.6228 7.01456 11.2939 6.60893 11.2939Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon 1.acad91ad90f9c6ef19d25102dabd0b59.svg";
export { ForwardRef as ReactComponent };